import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "http://localhost:9000",
  }),
  tagTypes: ["Books", "Book"],
  endpoints: (builder) => ({
    fetchBooks: builder.query({
      query: () => ({
        url: "/books",
        method: "GET",
      }),
      providesTags: ["Books"]
    }),
    getSingleBook: builder.query({
        query: (id) => ({
            url: `/books/${id}`,
            method: "GET",
        }),
        providesTags: (result, error, arg) => [
            {type: "Book", id: arg}
        ]
    })
    ,
    addBook: builder.mutation({
        query : (data) => ({
            url: '/books',
            method: 'POST',
            body: data
        }),
        invalidatesTags: ["Books"]
    }),
    editBook: builder.mutation({
        query: ({data, id}) => ({
            url: `/books/${id}`,
            method: 'PATCH',
            body: data,
        }),
        invalidatesTags: (result, error, arg) => [
            "Books",
            {type: "Book", id: arg.id}
        ]
    }),
    deleteBook: builder.mutation({
        query: (id) => ({
            url: `/books/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ["Books"]
    })
  }),
});

export default apiSlice;
export const { useFetchBooksQuery, useAddBookMutation, useEditBookMutation , useGetSingleBookQuery, useDeleteBookMutation } = apiSlice;
